/**
 * Set value to local storage
 * @param key
 * @param value
 */
export const setToLocalStorage = (key: string, value: string) => {
  if (typeof localStorage === "undefined") return;
  return localStorage?.setItem(key, value);
};

/**
 * Get value from local storage
 * @param key
 * @param value https://tsdoc.org/pages/packages/eslint-plugin-tsdoc
 */
export const getFromLocalStorage = (key: string) => {
  if (typeof localStorage === "undefined") return null;
  return localStorage?.getItem(key);
};
